var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:share-broken"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 12C4 12.4944 4.14662 12.9778 4.42133 13.3889C4.69603 13.8 5.08648 14.1205 5.54329 14.3097C6.00011 14.4989 6.50277 14.5484 6.98773 14.4519C7.47268 14.3555 7.91814 14.1174 8.26777 13.7677C8.6174 13.4181 8.8555 12.9727 8.95196 12.4877C9.04843 12.0028 8.99892 11.5001 8.8097 11.0433C8.62048 10.5865 8.30005 10.196 7.88893 9.92131C7.4778 9.6466 6.99445 9.49998 6.5 9.49998M14 6.49998L9 9.99998M14 17.5L9 14M16.5 21C16.9945 21 17.4778 20.8534 17.8889 20.5787C18.3 20.304 18.6205 19.9135 18.8097 19.4567C18.9989 18.9999 19.0484 18.4972 18.952 18.0123C18.8555 17.5273 18.6174 17.0818 18.2678 16.7322C17.9181 16.3826 17.4727 16.1445 16.9877 16.048C16.5028 15.9516 16.0001 16.0011 15.5433 16.1903C15.0865 16.3795 14.696 16.6999 14.4213 17.1111C14.1466 17.5222 14 18.0055 14 18.5M18.665 6.74998C18.4178 7.1782 18.0491 7.52348 17.6057 7.74218C17.1622 7.96087 16.6638 8.04315 16.1736 7.97861C15.6834 7.91407 15.2233 7.70561 14.8515 7.37959C14.4798 7.05357 14.2131 6.62463 14.0851 6.14702C13.9571 5.66941 13.9737 5.16457 14.1326 4.69636C14.2916 4.22815 14.5858 3.81758 14.9781 3.51658C15.3704 3.21558 15.8431 3.03767 16.3365 3.00535C16.8299 2.97302 17.3218 3.08774 17.75 3.33498",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.2136752d3f7ec91f5be5c7a52e84fda4.svg";
export { ForwardRef as ReactComponent };